/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var LeaseCommitmentType;
(function (LeaseCommitmentType) {
    LeaseCommitmentType["MONTH_TO_MONTH"] = "Month to Month";
    LeaseCommitmentType["FIXED"] = "Fixed";
})(LeaseCommitmentType || (LeaseCommitmentType = {}));
